import LogoIcon from "../icons/LogoIcon"
import { Link } from "@tanstack/react-router"
import { Separator } from "@/components/ui/separator"

export const Footer = () => {
  return (
    <footer className="border-t bg-muted/50">
      <div className="flex w-full flex-col items-center gap-4 py-10 px-4 md:px-8">
        <nav className="flex gap-6">
          <Link
            to="/kontakt"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Kontakt
          </Link>
          <Link
            to="/impressum"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Impressum
          </Link>
        </nav>
        <Separator className="max-w-xs" />
        <div className="flex flex-col items-center gap-2">
          <LogoIcon className="w-16" variant="iconOnly" />
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} - Martin Kupski
          </p>
        </div>
      </div>
    </footer>
  )
}
